export const isLaboratoryVisitCategory=(visit_category='')=>{
    return visit_category==='Employer Services - Labs' ||visit_category==='Urgent Care - Labs Only';
}
export const isPhysicalVisitCategory=(visit_category='')=>{
    return visit_category==='Employer Services - Physicals' || visit_category==='Employer Services - DOT Physicals';
}
export const hasConsentForm=(data)=>{
    return data===null? true:false
}
export const hasActivityConsent = (visitData) => {
    // Safely access the mapping_activity array using optional chaining
    const activities = visitData?.mapping_activity;
      let data=false;
    // Check if 'activities' is an array and then use .some() to check the condition
    if (Array.isArray(activities)) {
      console.log('activities', activities);
      data = activities.some(mapping => mapping?.activity?.active_consents);
      if(data){
          return false;
      }
      return true;
    }
   
    // Return false if mapping_activity doesn't exist or isn't an array
    return true;
  }
   
export const isDrugVisitCategory=(visit_category='')=>{
    return visit_category==='Employer Services - Drug Screens';
}
export const isMobileHealth = (
    services = [],
    contractService = [],
    activityList = [],
    physicalServices = []
  ) => {

  
    // Define allowed activity labels
    const allowedLabels = [
      "Mobile Health - Bundle V/ROS Exam & TB Assessment",
      "Mobile Health - TB Assessment",
      "Mobile Health - V/ROS Exam"
    ];
  
    // normalize inputs to arrays
    const normalize = (input) =>
      Array.isArray(input) ? input : input ? [input] : [];
  
    const serviceIds = normalize(services);
    const contractIds = normalize(contractService);
  
    // 🔹 1) Check services against activityList directly
    const serviceMatch =
      serviceIds.includes("ALL") || // 👈 if ALL present, always true
      activityList.some(
        (activity) =>
          serviceIds.includes(activity.value) &&
          allowedLabels.includes(activity.label)
      );
    console.log("serviceMatch", serviceMatch);
  
    // 🔹 2) Check contractService against physicalServices
    const contractMatch = physicalServices.some((ps) => {
      // Does this ps belong to a contractService ID?
      if (!contractIds.includes(ps.company_physical_id)) return false;
  
      // Check its physicalactivity array
      return ps.physicalactivity?.some((pa) =>
        allowedLabels.includes(pa.activity?.activity_name)
      );
    });
    // console.log("contractMatch", contractMatch);
  
    return serviceMatch || contractMatch;
  };

  export const isWorkCompVisitCategory = (visit_category = '', need_phy_therapy = 1) => {
    const wcCategory = [
      'Work Comp - Follow Up',
      'Work Comp - New Injury',
      'Work Comp - Other',
      'Urgent Care - Illness',
      'Urgent Care - Injury',
      ...(need_phy_therapy == 1 ? ['Work Comp - Physical Therapy'] : [])
    ];
  
    return wcCategory.includes(visit_category);
  };
  
export const getStatusAndColor = (resultStatus = 'pending') => {
    let statusClr = 'blue';
    let status = resultStatus;

    // Adjust status based on specific resultStatus values
    if (resultStatus === 'Completed/Administrated') {
        status = 'passed';
    } else if (resultStatus === 'Ordered') {
        status = 'pending';
    } else if (resultStatus === 'The subject Passed the fit test') {
        status = 'passed';
    } else if (resultStatus === 'The subject Failed the fit test') {
        status = 'failed';
    }

    // Determine color based on the updated status
    if (status.toLowerCase() === 'passed') {
        statusClr = 'green';
    } else if (status.toLowerCase() === 'failed') {
        statusClr = 'red';
    }

    return { statusClr, status };
};
export const getBillingStatusColor = (billingSts = '') => {
    if(!billingSts){
        return "#146dc7";
    }
    billingSts = billingSts.toLowerCase();
    if (billingSts == 'pending') {
        return "#146dc7";
    }
    else if (billingSts == 'no charge') {
        return "#7e48a0";
    }
    else if (billingSts=='ready to bill') {
        return  "#caa850"
    }
    else if (billingSts=='billing hold') {
        return  "#cb352e";
    }
    else if (billingSts=='billed') {
        return  "#118a2e";
    }
    return "#146dc7";
}
export const getActiveIds = (tableRecords) => {
    const { tableRows } = tableRecords;
    const activeIds = tableRows.data
        .filter((item) => item.data && item.data.isActive === 1)
        .map((item) => item.rowId)
        .join(',');
    return activeIds;
}
export const anyCheckboxSelected = (tableRecords) => {
    const { tableRows } = tableRecords;
    if (!tableRows || !Array.isArray(tableRows.data)) {
      return false;
    }

    return tableRows.data.some(item => item.data?.isActive === 1 || item.data?.isActive === true);
  }
export const getVisitStatusIcon = (sts = "New") => {
    const visitStatus = sts.toLowerCase();
    const statusGroups = {
        blue: ['New', 'Waiting Room', 'Checked In', 'Active'],
        green: ['Ready for Discharge', 'Discharge', 'Discharge Desk'],
        red: ['Cancelled', 'No Show', 'In Active'],
    };
    for (const [color, statuses] of Object.entries(statusGroups)) {
        if (statuses.some(status => status.toLowerCase() === visitStatus)) {
            return color;
        }
    }
    return 'blue';
};
export const getOverAllStatusIcon = (sts = "pending") => {
    let statusClr = 'blue';
    if (sts.toLowerCase() === 'passed') {
        statusClr = 'green';
    } else if (sts.toLowerCase() === 'failed') {
        statusClr = 'red';
    } else if(sts.toLowerCase() === 'pending results') {
        statusClr = 'yellow';
    }
    return statusClr;
};